export default function CalculateChecksumFactory(calculate) {
  return (file) =>
    new Promise((resolve, reject) => {
      calculate(file, (error, checksum) => {
        if (error) {
          reject(error);
          return;
        }

        resolve(checksum);
      });
    });
}
